export default function Header() {
    return (
        <div className="header">
            <div className="logo">wit</div>
            <div className="hero">Turn any Twitter thread into an insightful reading.</div>
        </div>
    )
}